import { getWork, getWorkForOwner } from '../api/workListApi';
import type { WorkWithDetailAndRelatedProjectData } from '../dto/EntityRepository';
import { useWorkViewStore } from '../store/WorkViewStore';
import { normalizeWorkData } from '../util/normalizeWorkData';
import { useOpenFromHash } from './useOpenFromHash';

/** `/@handle/works#workId` */
export const useWorkFromHash = () => {
  const activeWorkId = useWorkViewStore((s) => s.activeWork?.id ?? null);

  useOpenFromHash({
    activeId: activeWorkId,
    getActiveId: () => useWorkViewStore.getState().activeWork?.id ?? null,
    request: (_aui, id, isOwner) =>
      isOwner ? getWorkForOwner(id) : getWork(id),
    isInaccessible: (data, isOwner) => !isOwner && data.isPublic === false,
    open: publishWork,
  });
};

const publishWork = (data: WorkWithDetailAndRelatedProjectData) => {
  const work = normalizeWorkData(data);
  const store = useWorkViewStore.getState();
  store.setActiveWork(work);
  store.setActiveWorkDetailList(work.workDetailList);
  store.setActiveRelatedProjectList(work.relatedProjectList);
};
